import { render } from "./UploadReference.vue?vue&type=template&id=9f302430&scoped=true"
import script from "./UploadReference.vue?vue&type=script&lang=js"
export * from "./UploadReference.vue?vue&type=script&lang=js"

import "./UploadReference.vue?vue&type=style&index=0&id=9f302430&scoped=true&lang=css"

import exportComponent from "/home/gbl/SoftwareProjects/MyProjects/UniStuttgart/truscanWebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f302430"]])

export default __exports__